import { Field, Form, Formik } from "formik";
import { useEffect, useState } from "react";
import FormikInput from "../../../components/FormikFieldCustom";
import { createAuctionsValidationSchema } from "../../../utils/validations";
import DatePicker from "react-datepicker";
import { GetUserCategories } from "../../../services/categories.service";
import { StatusCodes } from "http-status-codes";
import { ICategoryDetail } from "../../admin/categories/category.interface";
import ButtonLoader from "../../../components/ButtonLoader";
import { CreateAuctionService } from "../../../services/auctions.service";
import { toast } from "react-toastify";
import moment from "moment";
import { GetLatLngWithAddress } from "../../../utils/getLatLngWithAddress";
import { fieldClass } from "../../../assets/classes/fieldClasses";
import GooglePlacesAutoComplete from "../../../components/GooglePlacesAutoComplete";
const CreateNewAuction = ({
  setSelectedTabs,
}: {
  setSelectedTabs?: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [categories, setCategories] = useState<ICategoryDetail[]>([]);
  const GetCategories = async () => {
    const response = await GetUserCategories();
    if (response.status && response.status_code === StatusCodes.OK) {
      setCategories(response.data);
    }
  };
  useEffect(() => {
    GetCategories();
  }, []);
  return (
    <div>
      <h1>Create New Auction</h1>
      <Formik
        validationSchema={createAuctionsValidationSchema}
        initialValues={{
          title: "",
          date: new Date(),
          category_id: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          description: "",
        }}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          const { lat, lng } = await GetLatLngWithAddress(
            `${values.address},${values.city},${values.state},${values.zip}`
          );
          if (lat && lng) {
            const response = await CreateAuctionService({
              ...values,
              time: moment(values.date).format("HH:mm:ss"),
              date: moment(values.date).format("YYYY-MM-DD"),
              lat: lat,
              lng: lng,
            });
            if (response.status && response.status_code === StatusCodes.OK) {
              toast.success(response.message);
              setSelectedTabs?.(1);
            } else {
              toast.error(response.message);
            }
          }
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <Form className="grid md:grid-cols-2 gap-4  xs:grid-cols-1 sm:grid-cols-2 mt-3 mb-2">
            <FormikInput name="title" label="Title" />
            <FormikInput
              options={categories.map((x) => {
                return { label: x.name, value: x.id };
              })}
              type="select"
              name="category_id"
              label="Select Category"
            />
            <div>
              <label className="block mb-2 text-sm text-gray-800">Date</label>
              <DatePicker
                minDate={new Date()}
                name="date"
                className={fieldClass}
                selected={values.date}
                onChange={(date) => setFieldValue("date", date)}
              />
            </div>
            <div>
              <label className="block mb-2 text-sm text-gray-800">
                Address
              </label>
              <GooglePlacesAutoComplete setFieldValue={setFieldValue} />
            </div>
            <FormikInput
              name="city"
              label="City"
              type="text"
              autoComplete="address-level2"
            />
            <FormikInput
              name="state"
              label="State"
              type="text"
              autoComplete="address-level3"
            />
            <FormikInput
              name="zip"
              label="Zip code"
              type="text"
              autoComplete="postal-code"
            />
            <FormikInput
              type="textarea"
              row="4"
              name="description"
              label="Description"
            />
            <button
              type="submit"
              className="border-2 px-1 border-gray-600 bg-gray-400 grid grid-cols-1"
            >
              {isSubmitting ? (
                <>
                  <ButtonLoader />
                  Loading...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CreateNewAuction;
